import { Component, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { vshrink } from 'shared';

import { TWizardStepId } from '../../../interfaces';
import { AppSettingsService, TenantService } from '../../../services';
import { WizardMapComponent } from '../../wizard-map/wizard-map.component';
import { WizardStepBaseComponent } from '../base/wizard-step-base.component';

@Component({
    selector: 'app-wizard-step-location',
    templateUrl: './wizard-step-location.component.html',
    styleUrls: ['../base/wizard-step-base.component.scss', './wizard-step-location.component.scss'],
    animations: [vshrink()],
    imports: [FormsModule, WizardMapComponent, TranslatePipe],
})
export class WizardStepLocationComponent extends WizardStepBaseComponent {
    private readonly appSettings = inject(AppSettingsService);
    private readonly tenantService = inject(TenantService);

    public id: TWizardStepId = 'location';
    public nextButtonLabel = 'next';

    @ViewChild(WizardMapComponent) public map: WizardMapComponent;
    public enableMap = true;

    public geocodeLocation(): void {
        this.map.geocodeLocation(this.form.location);
    }

    protected submitWizardStep(): Observable<boolean> {
        const config = this.map.getSettings();
        if (this.enableMap) {
            return this.tenantService.updateConfig(config);
        } else {
            return of(true);
        }
    }
}
